const COUNTER_TYPE_CHARACTERS = 'chars';
const COUNTER_TYPE_WORDS = 'words';

export default {
  props: {
    limit: {
      type: Number,
    },
    softLimit: {
      type: Boolean,
    },
    counter: {
      type: Boolean,
    },
    counterType: {
      type: String,
      default: COUNTER_TYPE_CHARACTERS,
    },
    recommendedMin: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      textLength: false,
    };
  },
  computed: {
    counterClass() {
      return {
        'input-group__counter': true,
        'input-group__counter--error': false,
        'input-group__counter--soft-limit-reached': this.softLimitReached,
        'input-group__counter--recommended-min-reached': this.recommendedMinReached,
      };
    },
    counterShowValue() {
      if (this.limit) {
        return `${this.textLength || 0} / ${this.limit}`;
      }
      return this.textLength || 0;
    },
    textLengthIsValid() {
      if (!this.limit || this.softLimit) {
        return true;
      }
      return this.textLength <= this.limit;
    },
    softLimitReached() {
      if (!this.limit || !this.softLimit) {
        return false;
      }
      return this.textLength > this.limit;
    },
    recommendedMinReached() {
      if (!this.recommendedMin) {
        return false;
      }
      return this.recommendedMin < this.textLength;
    },
    counterValidationObject() {
      return {
        quillCharacterLength: this.textLengthIsValid ? 'valid' : 'invalid',
        quillWordLength: this.textLengthIsValid ? 'valid' : 'invalid',
      };
    },
  },
  methods: {
    updateCharactersCount(length) {
      if (this.counterType === COUNTER_TYPE_CHARACTERS) {
        this.textLength = length;
      }
    },
    updateWordsCount(text) {
      if (this.counterType === COUNTER_TYPE_WORDS) {
        this.textLength = text.length > 0
          ? text
            .trim()
            .replaceAll('\n', ' ')
            .split(/\s+/)
            .filter(word => word !== '')
            .length
          : 0;
      }
    },
  },
};
